import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import 'common/css/master.css';

import ActivityTabs from "./activityTabs";
import AssessmentActivity from "./assessmentActivity";

import { getStudentAssessmentInfoSvc, getActivityListSvc } from "./parentAssessmentSvc";

const Assessment = (props) => {
    const { setLoader, setOpacity, schoolId, acdYrId, studentId, clsId } = props;

    const [activityId, setActivityId] = useState(0);  // Ensure activityId is a number
    const [lstActivity, setLstActivity] = useState([]);
    const [lstStudentInfo, setLstStudentInfo] = useState([]);
    const [imageBasePath, setImageBasePath] = useState(null);
    const imageService = "https://www.sms.cooledsys.com:8280/sms/student/docs/view?imgPath=";

    useEffect(() => {
        // console.log("Assessment called");
        if (schoolId && acdYrId && studentId)
            getStudentAssessmentInfo(schoolId, acdYrId, studentId, clsId);
        getActivityList(schoolId, acdYrId, studentId, clsId);
    }, [schoolId, acdYrId, studentId, clsId]);


    const getActivityList = (schoolId, acdYrId, studentId, clsId) => {
        // console.log("getActivityList called");
        setLoader("block");
        setOpacity(0.5);
        getActivityListSvc(schoolId, acdYrId, studentId, clsId, studentActivityListResponse);
    }

    const studentActivityListResponse = (data) => {
        // console.log("studentActivityListResponse called, data", data);
        if (data.status === "Success") {
            setLstActivity(data.lstActivity);
            // if (data.lstActivity && data.lstActivity.length) {
            //     setActivityId(data.lstActivity[0].activityId);
            // }
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const getStudentAssessmentInfo = (schoolId, acdYrId, studentId, clsId) => {
        // console.log("getStudentAssessmentInfo called");
        setLoader("block");
        setOpacity(0.5);
        getStudentAssessmentInfoSvc(schoolId, acdYrId, studentId, clsId, studentAssessmentInfoResponse);
    }

    const studentAssessmentInfoResponse = (data) => {
        // console.log("studentAssessmentInfoResponse called, data", data);
        if (data.status === "Success") {
            setImageBasePath(data.basePathActivity);
            setLstStudentInfo(data.lstStudentInfo);
        } else if (data.status === "Failure") {
            toast.error(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }



    return (
        <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                {
                    lstActivity ? lstActivity.map((activity) => (
                        <div key={activity.activityId}
                            className="col-md-12 col-sm-12 col-xs-12 padding-remove"
                            style={{ border: "1px solid #ccc", borderRadius: "10px", marginBottom:"5px" }}>
                            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                                <div
                                    onClick={() => setActivityId(activity.activityId === activityId ? 0 : activity.activityId)}
                                    className="activity-row"
                                    style={{
                                        backgroundColor: activity.activityId === activityId ? "#AFE1AF" : "#D3D3D3", // Light green when selected, grey otherwise
                                        borderColor: activity.activityId === activityId ? "#1890ff" : "#ccc" // Blue border when selected, grey otherwise
                                    }}
                                >
                                    {activity.activity}
                                </div>

                            </div>
                            <div className="col-md-12 col-sm-12 col-xs-12 padding-remove">
                                {activity.activityId === activityId && (
                                    <AssessmentActivity
                                        activityObj={lstStudentInfo.find(a => a.activityId === activityId) ?? {}}
                                        imageBase={imageService + imageBasePath + "/"}
                                    />
                                )}
                            </div>
                        </div>
                    )) : null
                }

            </div>
        </div>
    );
}

export default Assessment;
